<template>
  <div class="wx-open-message-configure-tpl"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="templates">
      <div class="main">
        <div class="main-cont"
             v-loading="committing"
             element-loading-text="数据处理中，请稍等...">
          <template v-if="templates.length">
            <div class="tpl-main">
              <DataGrid size="mini"
                        height="auto"
                        highlight-current-row
                        highlight-hover-row
                        resizable
                        :data="templates">
                <DataGridColumn title="模板ID"
                                field="priTmplId"
                                min-width="180"
                                align="center"></DataGridColumn>
                <DataGridColumn title="模版标题"
                                field="title"
                                min-width="100"
                                align="center"></DataGridColumn>
                <DataGridColumn title="模版内容"
                                field="content"
                                min-width="180"></DataGridColumn>
                <DataGridColumn title="模版示例"
                                field="example"
                                min-width="180"></DataGridColumn>
                <DataGridColumn title="模版类型"
                                field="type"
                                min-width="100"
                                align="center">
                  <template #default="{row}">
                    <span>{{row.type | tplType}}</span>
                  </template>
                </DataGridColumn>
                <DataGridColumn title="操作"
                                width="100"
                                align="center"
                                fixed="right">
                  <template #default="{row}">
                    <el-button size="mini"
                               type="text"
                               @click="handleDelete(row)">删除模板</el-button>
                  </template>
                </DataGridColumn>
              </DataGrid>
            </div>
          </template>
          <template v-else>
            <Hint>
              <div>公众号未订阅模板</div>
            </Hint>
          </template>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="text"
                   icon="el-icon-refresh"
                   @click="loadTemplates">刷新列表</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>模板数据加载失败</div>
        <el-button type="text"
                   @click="loadTemplates">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'WxOpenMessageConfigureTpl',
  components: {
    DataGrid,
    DataGridColumn,
    Hint
  },
  data () {
    return {
      loading: false,
      templates: null,
      committing: false
    }
  },
  filters: {
    tplType (type) {
      switch (type) {
        case 2:
          return '一次性订阅'
        case 3:
          return '长期订阅'
        default:
          return type
      }
    }
  },
  methods: {
    loadTemplates () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/open/templates',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.templates = response.data['templates'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleDelete (template) {
      this.$confirm('确定要删除选择的模板吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/message/wx/open/delTemplate',
          method: 'post',
          data: this.$qs.stringify({
            priTmplId: template.priTmplId
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.loadTemplates()
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.loadTemplates()
  }
}
</script>

<style lang="scss">
  .wx-open-message-configure-tpl {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .tpl-main {
          position: absolute;
          left: 10px;
          top: 10px;
          right: 10px;
          bottom: 10px;
        }
      }
    }
    & > .footer {
      flex: none;
      height: 42px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 40px;
    }
  }
</style>
